import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const SeoDescriptionSection = () => {
    return (
        <section className="py-16 bg-[#f5fefd] border-t border-gray-100">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Say-Hot nedir?</h2>

                    <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                        <p>
                            Say-Hot, Türkiye'nin 81 ilini kapsayan en kapsamlı etkinlik ve gezi rehberidir.
                            Amacımız, sadece popüler şehirleri değil, ülkenin dört bir yanındaki gizli kalmış güzellikleri,
                            yerel festivalleri ve kültürel etkinlikleri tek bir platformda buluşturmaktır.
                        </p>

                        <p>
                            Kullanıcı dostu arayüzümüz sayesinde gitmek istediğiniz şehri ve tarihi seçerek o bölgedeki
                            tüm konserleri, doğa yürüyüşlerini, müzeleri ve özel etkinlikleri anında görüntüleyebilirsiniz.
                            Artık "Hafta sonu nereye gitsem?" diye düşünmenize gerek yok.
                        </p>

                        <p>
                            Gelişmiş yapay zekâ teknolojimiz ile size özel gezi rotaları oluşturuyoruz.
                            İlgi alanlarınıza, bütçenize ve zamanınıza en uygun planı saniyeler içinde hazırlayarak,
                            seyahat deneyiminizi unutulmaz kılıyoruz. Say-Hot ile Türkiye'yi yeniden keşfedin.
                        </p>
                    </div>

                    <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
                        <Link to="/about" className="group flex items-center justify-center text-blue-600 font-semibold hover:text-blue-800 transition-colors p-3 bg-white rounded-lg shadow-sm hover:shadow-md">
                            <span>Hakkımızda</span>
                            <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" />
                        </Link>

                        <Link to="/blog?category=Etkinlikler" className="group flex items-center justify-center text-blue-600 font-semibold hover:text-blue-800 transition-colors p-3 bg-white rounded-lg shadow-sm hover:shadow-md">
                            <span>Türkiye Etkinlik Takvimi</span>
                            <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" />
                        </Link>

                        <Link to="/start-plan" className="group flex items-center justify-center text-blue-600 font-semibold hover:text-blue-800 transition-colors p-3 bg-white rounded-lg shadow-sm hover:shadow-md">
                            <span>Yapay Zekâ ile Planla</span>
                            <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SeoDescriptionSection;
